import { createSlice } from "@reduxjs/toolkit";

import { complexityList } from "utils/shared/variables";
import {
  createNewProgram,
  createNewProgramModule,
  deleteProgram,
  deleteProgramChapter,
  deleteProgramModule,
  discardStagedQuestion,
  duplicateProgram,
  duplicateProgramModule,
  fetchAllOrganization,
  fetchAllPrograms,
  fetchAllProgramsModules,
  fetchAllProgramsQuestions,
  fetchProgramBulkUploadReview,
  fetchProgramBulkUploadReviewQuestion,
  fetchProgramCategoryFilters,
  fetchProgramChapters,
  fetchProgramDetails,
  fetchProgramFilters,
  fetchProgramOrModuleInternalNotesFilters,
  fetchProgramLearningPointFilters,
  fetchProgramModuleDetails,
  fetchProgramQuesDetails,
  fetchProgramsRecommendedQuestions,
  fetchProgramTypeFilters,
  fetchQuestionAnalytics,
  publishStagedQuestion,
  updateNewProgram,
  updateProgramQuestion,
  updateStagedQuestion,
  uploadBulkUploadFile,
  fetchQuestionTags,
  fetchAllLearningPoints,
} from "redux/actions/programs/programsData";

const initialState = {
  // API states - Common filters
  programFilters: {},
  programFiltersLoading: true,
  programFiltersChange: false,
  programLearningFilters: {
    category: [],
    learningPoint: [],
    categoryCount: 0,
    learningPointCount: 0,
  },
  programInternalNotesLoading: false,
  programInternalNotesList: [],
  programInternalNotesCount: 0,
  programTypesList: [],
  programTypesLoading: false,
  programTypesCount: 0,

  programLearningFiltersCategoryPage: 1,
  programLearningFiltersCategoryPageSize: 20,
  programLearningFiltersLPPage: 1,
  programLearningFiltersLPPageSize: 20,
  programLearningFiltersLoading: true,
  filterProgramTypePage: 1,
  selectedProgramTypeFilter: [],
  filterProgramInternalNotesPage: 1,
  selectedProgramInternalNotesFilter: [],
  questionTagFilter: [],
  // API states - Program questions
  programQues: [],
  programQuesCount: 0,
  programQuesPage: 1,
  lastQuestUpdated: "",
  programQuesPageSize: 10,
  programQuesLoading: true,
  programQuesDetails: {},
  programQuesDetLoading: true,
  programQuesAnalytics: {},
  programQuesAnalyticsLoading: true,
  programRecQues: [],
  programRecQuesCount: 0,
  programRecQuesPage: 1,
  programRecQuesPageSize: 10,
  programRecQuesLoading: false,
  questionTags: [],
  questionTagsLoading: false,
  questionTagsCount: 0,
  questionTagsPage: 1,
  // API states - Program questions uploader
  programQuesUploadReviewLoading: true,
  programQuesUploaderReviewCountTotal: 0,
  programQuesUploaderReviewCountApproved: 0,
  programQuesUploaderReviewCountError: 0,
  programQuesUploaderReviewErrorList: [],
  programQuesUploaderValidationList: [],
  programQuesUploaderProgress: 0,
  programQuesUploadFileName: "",
  programQuesUploadFileSize: "",
  programQuesUploadFileType: "",
  programQuesUploadEditLoading: true,
  programQuesUploadEditStatus: "",
  programQuesUploadEditType: "",
  programQuesUploadEditQuestion: "",
  programQuesUploadEditChoices: [],
  programQuesUploadEditAnswer: [],
  programQuesUploadEditExplanation: "",
  programQuesUploadEditCategory: [],
  programQuesUploadEditLearningPoint: [],
  programQuesUploadTag: [],
  programQuesUploadEditComplexity: "",
  programQuesUploadEditModuleType: [],
  programQuesUploadEditUserRole: [],
  programQuesUploadEditv28Compatibility: null,
  programQuesUploadEditErrorList: {},
  programQuesEditSaveLoading: false,
  programQuesPublishLoading: false,
  programQuesUploadEditData: {},
  programQuesBulkDiscardLoading: false,
  // API States - Program questions Update
  programQuesLoading: false,
  programQuesUpdateErrors: {},
  programQuestionUpdateDetail: {},

  // API states - Program modules
  programModules: [],
  programModuleDetail: {},
  programModulesCount: 0,
  programModulesPage: 1,
  programModulesPageSize: 10,
  programModulesLoading: true,
  programModuleDetailLoading: true,
  programModuleDeleting: false,
  programModuleDuplicating: false,
  programModuleCreating: false,
  programModulesCreateSelQues: [],
  programModulesCreateSelQuesDisplay: [],
  // API states - Program creator
  programDetail: {},
  programCreateSelModules: [],
  programCreateExistingModules: [],
  programCreateSelModulesDisplay: [],
  programListCount: 0,
  programListPage: 1,
  programListPageSize: 10,
  programList: [],
  programListLoading: true,
  programListClientAdminlist: [],
  programDeleting: false,
  programDuplicating: false,
  programDetailLoading: false,
  programChaptersLoading: false,
  programChaptersList: [],
  programOrgLoading: false,
  programOrgList: [],
  programOrgListCount: 0,
  programOrgListPage: 1,
  programOrgListPageSize: 10,
  sortOrderBy: "",
  // Table filters
  selectedStatusFilter: "",
  selectedStatusesFilter: [],
  selectedModuleFilter: [],
  selectedQuesTypeFilter: [],
  programModuleMediaType: [],
  selectedLastAssignedDateTxt: "",
  selectedLastAssignedDate: {},
  selectedRoleFilter: [],
  selectedCategoryFilter: [],
  selectedLearnPointFilter: [],
  selectedComplexityFilter: [],
  selectedPrimaryTagFilter: [],
  // Page level data states - program module
  moduleStep1ErrValidate: false,
  moduleCreateName: "",
  moduleMedia: "",
  moduleCreateDescription: "",
  moduleCreateInternalNotes: "",
  moduleCreateWithCertificate: false,
  moduleCreateType: [],
  moduleCreateRole: [],
  moduleCreateCategory: [],
  moduleCreateLearnPoint: [],
  moduleCreateFeedVideo: null,
  // Page level data states - programs
  programCreateLoading: false,
  programCreateErrValidate: false,
  programCreateCoverImagePreview: null,
  programCreateHeading: "",
  programCreateSubHeading: "",
  programCreateInternalType: "",
  programCreateInternalNotes: "",
  programCreateDescription: "",
  programCreateStructure: "",
  programCreateLearnObjs: "",
  programCreateCME: 0,
  programCreateIsSequential: false,
  programCreateIsMandatory: false,
  programCreateRole: [],
  programCreateUserType: [],
  programHandouts: [],
  programHandoutsClientAdmin: [],
  hasSubmissions: null,
  programCreateCategory: [],
  programCreateLearnPoint: [],
  programCreateAssignedOrgs: [],
  programCreateAssignedUsers: [],
  programCreateAssignedUserGroups: [],
  programType: "",
  programsLoadedUserPage: 1,
  programsLoadedUserPageSize: 10,
  programsLoadedUserGroupPage: 1,
  programsLoadedUserGroupPageSize: 10,
  programVisibleAllOrgs: false,
  // ui states
  programModulesCreateStep: 1,
  selectedModTypeIndex: 0,
  programCreateStep: 1,
  programsCreateSkeletonData: [
    {
      height: 40,
      marginBottom: "10px",
    },
    {
      height: 100,
      marginBottom: "8px",
    },
    {
      height: 100,
      marginBottom: "8px",
    },
    {
      height: 100,
      marginBottom: "8px",
    },
    {
      height: 100,
      marginBottom: "8px",
    },
  ],
  programLearningPointsLoading: false,
  programLearningPoints: [],
  programLearningPointsCount: 0,
  programLearningPointsPage: 1,
  programLearningPointsPageSize: 10,
  programVisibilityCustomerAdmin: "no",
  programVisibilityCoder: "no",
  programVisibility: [],
  programVisibleToOrgs: [],
};

export const programsSlice = createSlice({
  name: "programs",
  initialState,
  reducers: {
    // Common update
    setProgramSliceData: (state, { payload }) => {
      if (payload.type && payload.type in state) {
        state[payload.type] = payload.data;
      }
    },
    // reset handout detail
    resetHandoutDetail: (state) => {
      state.programHandouts = [];
    },
    appendUpdatedHandout: (state, { payload }) => {
      state.programHandouts.push(payload);
    },
    updateProgramHandout: (state, { payload }) => {
      state.programHandouts = payload;
    },
    toggleProgramSliceArrayData: (state, { payload }) => {
      if (payload.type && payload.type in state) {
        if (state[payload.type].includes(payload.data)) {
          // remove from array of question ids
          state[payload.type].splice(
            state[payload.type].indexOf(payload.data),
            1
          );
        } else {
          state[payload.type].push(payload.data);
        }
      }
    },
    // Module state update
    resetProgramModuleCreateData: (state, { payload }) => {
      state.moduleCreateName = "";
      state.moduleCreateDescription = "";
      state.moduleCreateInternalNotes = "";
      state.moduleCreateWithCertificate = false;
      state.moduleCreateType = [];
      state.moduleCreateRole = [];
      state.moduleCreateCategory = [];
      state.moduleCreateLearnPoint = [];
      state.moduleCreateFeedVideo = null;
      state.programModulesCreateSelQues = [];
      state.programModulesCreateSelQuesDisplay = [];
      state.moduleStep1ErrValidate = false;
      state.programModulesCreateStep = 1;
      state.programQuesPage = 1;
      state.programQuesPageSize = 10;
      state.lastQuestUpdated = "";
      state.programType = "";
    },
    toggleModCreateQuesSelect: (state, { payload }) => {
      if (payload && payload.question_id) {
        if (state.programModulesCreateSelQues.includes(payload.question_id)) {
          // remove from array of question ids
          state.programModulesCreateSelQues.splice(
            state.programModulesCreateSelQues.indexOf(payload.question_id),
            1
          );
          // remove from array of question data
          for (
            let i = 0;
            i < state.programModulesCreateSelQuesDisplay.length;
            i++
          ) {
            if (
              state.programModulesCreateSelQuesDisplay[i].question_id ===
              payload.question_id
            ) {
              state.programModulesCreateSelQuesDisplay.splice(i, 1);
            }
          }
        } else {
          state.programModulesCreateSelQues.push(payload.question_id);
          state.programModulesCreateSelQuesDisplay.push(payload);
        }
      }
    },
    setModuleCreateStep: (state, { payload }) => {
      state.programModulesCreateStep = payload;
    },
    // Program create updates
    setProgCreateStep: (state, { payload }) => {
      state.programCreateStep = payload;
    },
    setProgramCreateSelModulesDisplay: (state, { payload }) => {
      state.programCreateSelModulesDisplay = payload;
    },
    resetProgramCreateData: (state, { payload }) => {
      state.programCreateErrValidate = false;
      state.programCreateStep = 1;
      state.programModulesPage = 1;
      state.programModulesPageSize = 10;
      state.programCreateCoverImagePreview = null;
      state.programCreateHeading = "";
      state.programCreateSubHeading = "";
      state.programCreateInternalType = "";
      state.programCreateInternalNotes = "";
      state.programCreateDescription = "";
      state.programCreateStructure = "";
      state.programCreateLearnObjs = "";
      state.programCreateCME = 0;
      state.programCreateRole = [];
      state.programCreateUserType = [];
      state.programHandouts = [];
      state.programCreateCategory = [];
      state.programCreateLearnPoint = [];
      state.programCreateAssignedOrgs = [];
      state.programCreateAssignedUsers = [];
      state.programCreateAssignedUserGroups = [];
      state.programCreateIsSequential = false;
      state.programCreateIsMandatory = false;
      state.programsLoadedUserPage = 1;
      state.programsLoadedUserPageSize = 10;
      state.programsLoadedUserGroupPage = 1;
      state.programsLoadedUserGroupPageSize = 10;
      state.programOrgListPage = 1;
      state.programOrgListPageSize = 10;
      state.programCreateSelModules = [];
      state.programCreateExistingModules = [];
      state.programCreateSelModulesDisplay = [];
      state.programVisibleToOrgs = [];
      state.programVisibility = [];
      state.programVisibleAllOrgs = false;
      state.programType = "";
    },
    toggleProgCreateModsSelect: (state, { payload }) => {
      if (payload.moduleData && payload.moduleData.module_id) {
        if (
          state.programCreateSelModules.includes(payload.moduleData.module_id)
        ) {
          // remove from array of module ids
          state.programCreateSelModules.splice(
            state.programCreateSelModules.indexOf(payload.moduleData.module_id),
            1
          );
          // remove from array of module data
          for (
            let i = 0;
            i < state.programCreateSelModulesDisplay.length;
            i++
          ) {
            if (
              state.programCreateSelModulesDisplay[i].module_id ===
              payload.moduleData.module_id
            ) {
              state.programCreateSelModulesDisplay.splice(i, 1);
            }
          }
        } else {
          state.programCreateSelModules.push(payload.moduleData.module_id);
          const progCreateSelModChapterSettings = {
            is_mandatory: payload?.chapterData?.is_mandatory
              ? payload.chapterData.is_mandatory
              : true,
            show_answer: payload?.chapterData?.show_answer
              ? payload.chapterData.show_answer
              : true,
            initial_certification: payload?.chapterData?.initial_certification
              ? payload.chapterData.initial_certification
              : false,
            recertification: payload?.chapterData?.recertification
              ? payload.chapterData.recertification
              : false,
            non_dt_certification: payload?.chapterData?.non_dt_certification
              ? payload.chapterData.non_dt_certification
              : false,
            chapter_type: payload?.chapterData?.chapter_type
              ? payload.chapterData.chapter_type
              : "TM",
            order: payload?.chapterData?.order
              ? payload.chapterData.order
              : state.programCreateSelModulesDisplay.length,
            chapter_id: payload?.chapterData?.chapter_id
              ? payload.chapterData.chapter_id
              : null,
          };
          const progCreateSelModChapterData = {
            ...payload.moduleData,
            ...progCreateSelModChapterSettings,
          };
          state.programCreateSelModulesDisplay.push(
            progCreateSelModChapterData
          );
        }
      }
    },
    removeDeletedFromExistingModules: (state, { payload }) => {
      if (state.programCreateExistingModules.includes(payload.moduleId)) {
        // remove from array of module ids
        state.programCreateExistingModules.splice(
          state.programCreateExistingModules.indexOf(payload.moduleId),
          1
        );
      }
    },
    addToProgCreateModsSelect: (state, { payload }) => {
      if (payload.moduleData && payload.moduleData.module_id) {
        if (
          !state.programCreateSelModules.includes(payload.moduleData.module_id)
        ) {
          state.programCreateSelModules.push(payload.moduleData.module_id);
          state.programCreateExistingModules.push(payload.moduleData.module_id);
          const progCreateSelModChapterSettings = {
            is_mandatory: payload?.chapterData?.is_mandatory
              ? payload.chapterData.is_mandatory
              : false,
            show_answer: payload?.chapterData?.show_answer
              ? payload.chapterData.show_answer
              : false,
            initial_certification: payload?.chapterData?.initial_certification
              ? payload.chapterData.initial_certification
              : false,
            recertification: payload?.chapterData?.recertification
              ? payload.chapterData.recertification
              : false,
            non_dt_certification: payload?.chapterData?.non_dt_certification
              ? payload.chapterData.non_dt_certification
              : false,
            chapter_type: payload?.chapterData?.chapter_type
              ? payload.chapterData.chapter_type
              : "TM",
            order: payload?.chapterData?.order
              ? payload.chapterData.order
              : state.programCreateSelModulesDisplay.length,
            chapter_id: payload?.chapterData?.chapter_id
              ? payload.chapterData.chapter_id
              : null,
          };
          const progCreateSelModChapterData = {
            ...payload.moduleData,
            ...progCreateSelModChapterSettings,
          };
          state.programCreateSelModulesDisplay.push(
            progCreateSelModChapterData
          );
          // Sort programs selected display list
          let sortedProgramCreateSelModulesDisplay =
            state.programCreateSelModulesDisplay.sort((p1, p2) =>
              p1.order > p2.order ? 1 : p1.order < p2.order ? -1 : 0
            );
          state.programCreateSelModulesDisplay =
            sortedProgramCreateSelModulesDisplay;
        }
      }
    },
    updateProgModChapterFields: (state, { payload }) => {
      // update chapter field from array of chapter data
      for (let i = 0; i < state.programCreateSelModulesDisplay.length; i++) {
        if (
          state.programCreateSelModulesDisplay[i].module_id ===
          payload.module_id
        ) {
          // update fields
          if (payload.type === "is_mandatory") {
            state.programCreateSelModulesDisplay[i].is_mandatory =
              payload.value;
          } else if (payload.type === "show_answer") {
            state.programCreateSelModulesDisplay[i].show_answer = payload.value;
          } else if (payload.type === "initial_certification") {
            state.programCreateSelModulesDisplay[i].initial_certification =
              payload.value;
          } else if (payload.type === "recertification") {
            state.programCreateSelModulesDisplay[i].recertification =
              payload.value;
          } else if (payload.type === "non_dt_certification") {
            state.programCreateSelModulesDisplay[i].non_dt_certification =
              payload.value;
          }
        }
      }
    },
    // Question update
    setQuestionUpdateState: (state, { payload }) => {
      state.programQuestionUpdateDetail = {
        ...state.programQuestionUpdateDetail,
        ...payload,
      };
      // reset validation errors of the payload if they exist
      for (const key in payload) {
        if (key in state.programQuesUpdateErrors) {
          delete state.programQuesUpdateErrors[key];
        }
      }
      //  if payload contains options or answer, then delete both keys
      if (payload.choices || payload.answer || payload.type) {
        delete state.programQuesUpdateErrors.choices;
        delete state.programQuesUpdateErrors.answer;
        delete state.programQuesUpdateErrors.type;
      }
    },
    setQuestionUpdateValidationErrors: (state, { payload }) => {
      state.programQuesUpdateErrors = payload;
    },
    validateProgramQuestion: (state) => {
      const errors = {};
      if (!state.programQuestionUpdateDetail.question) {
        errors.question = "Question is required";
      }
      if (
        !state.programQuestionUpdateDetail.choices ||
        state.programQuestionUpdateDetail.choices.length === 0
      ) {
        errors.choices = "Choices are required";
      }
      if (!state.programQuestionUpdateDetail.answer) {
        errors.answer = "Answer is required";
      }
      if (!state.programQuestionUpdateDetail.explanation) {
        errors.explanation = "Explanation is required";
      }
      if (
        !state.programQuestionUpdateDetail.category ||
        state.programQuestionUpdateDetail.category.length === 0
      ) {
        errors.category = "Category is required";
      }
      if (
        !state.programQuestionUpdateDetail.learning_point ||
        state.programQuestionUpdateDetail.learning_point.length === 0
      ) {
        errors.learning_point = "Learning point is required";
      }
      if (!state.programQuestionUpdateDetail.v28_compatibility) {
        errors.v28_compatibility = "V28 compatibility is required";
      }
      switch (state.programQuestionUpdateDetail.type) {
        case "SC": // Single Choice
          if (state.programQuestionUpdateDetail.answer !== 1) {
            errors.answer =
              "Single choice question should have only one answer";
          }
          break;
        case "MC": // Multiple Choice
          if (state.programQuestionUpdateDetail.answer < 1) {
            errors.answer =
              "Multiple choice question should have at least one answer";
          }
          break;

        case "BC": // Boolean Choice
          if (state.programQuestionUpdateDetail.choices.length !== 2) {
            errors.choices =
              "Boolean choice question should have exactly two choices";
          }
          if (state.programQuestionUpdateDetail.answer !== 1) {
            errors.answer =
              "Boolean choice question should have exactly one answer";
          }
          break;
      }
      // check if atleast 2 choices are provided
      if (state.programQuestionUpdateDetail.choices.length < 2) {
        errors.choices = "At least 2 choices are required";
      }
      state.programQuesUpdateErrors = errors;
    },
  },
  extraReducers: {
    // Programs filters
    [fetchProgramFilters.pending]: (state) => {
      state.programFiltersLoading = true;
    },
    [fetchProgramFilters.fulfilled]: (state, { payload }) => {
      let payloadData = payload;
      // FE check for remove WM - not needed currently
      if (
        payloadData?.module_type &&
        payloadData.module_type instanceof Array &&
        payloadData.module_type.includes("WM")
      ) {
        const index = payloadData.module_type.indexOf("WM");
        payloadData.module_type.splice(index, 1);
      }
      state.programFilters = payloadData;
      state.programFiltersLoading = false;
    },
    [fetchProgramFilters.rejected]: (state, { payload }) => {
      state.programFiltersLoading = false;
    },
    // Programs Category filters
    [fetchProgramCategoryFilters.pending]: (state) => {
      state.programLearningFiltersLoading = true;
    },
    [fetchProgramCategoryFilters.fulfilled]: (state, { payload }) => {
      state.programLearningFilters.category = payload?.results
        ? payload.results
        : [];
      state.programLearningFilters.categoryCount = payload?.count
        ? payload.count
        : 0;
      state.programLearningFiltersLoading = false;
    },
    [fetchProgramCategoryFilters.rejected]: (state, { payload }) => {
      state.programLearningFiltersLoading = false;
    },
    // Programs Learning Point filters
    [fetchProgramLearningPointFilters.pending]: (state) => {
      state.programLearningFiltersLoading = true;
    },
    [fetchProgramLearningPointFilters.fulfilled]: (state, { payload }) => {
      state.programLearningFilters.learningPoint = payload?.results
        ? payload.results
        : [];
      state.programLearningFilters.learningPointCount = payload?.count
        ? payload.count
        : 0;
      state.programLearningFiltersLoading = false;
    },
    [fetchProgramLearningPointFilters.rejected]: (state, { payload }) => {
      state.programLearningFiltersLoading = false;
    },
    [fetchQuestionTags.pending]: (state) => {
      state.questionTagsLoading = true;
    },
    [fetchQuestionTags.fulfilled]: (state, { payload }) => {
      state.questionTags = payload?.results.map((e) => e.name);
      state.questionTagsCount = payload?.count ? payload.count : 0;
      state.questionTagsLoading = false;
    },
    [fetchQuestionTags.rejected]: (state, { payload }) => {
      state.questionTagsLoading = false;
    },
    // Programs questions
    [fetchAllProgramsQuestions.pending]: (state) => {
      state.programQuesLoading = true;
      state.programQuesCount = 0;
      state.programQues = [];
    },
    [fetchAllProgramsQuestions.fulfilled]: (state, { payload }) => {
      state.programQues = payload?.results;
      state.programQuesCount = payload?.count ? payload.count : 0;
      state.programQuesLoading = false;
      state.lastQuestUpdated = payload?.last_updated_question;
    },
    [fetchAllProgramsQuestions.rejected]: (state, { payload }) => {
      state.programQuesLoading = false;
    },
    // Programs questions
    [fetchProgramQuesDetails.pending]: (state) => {
      state.programQuesDetLoading = true;
    },
    [fetchProgramQuesDetails.fulfilled]: (state, { payload }) => {
      state.programQuesDetails = payload ? payload : {};
      state.programQuesDetails.complexity = payload?.complexity
        ? payload.complexity && complexityList.includes(payload.complexity)
          ? payload.complexity
          : "BEGINNER"
        : "BEGINNER";
      state.programQuesDetLoading = false;
    },
    [fetchProgramQuesDetails.rejected]: (state, { payload }) => {
      state.programQuesDetLoading = false;
    },
    // Programs recommended questions
    [fetchProgramsRecommendedQuestions.pending]: (state) => {
      state.programRecQuesLoading = true;
    },
    [fetchProgramsRecommendedQuestions.fulfilled]: (state, { payload }) => {
      state.programRecQues = payload?.results;
      state.programRecQuesCount = payload?.count ? payload.count : 0;
      state.programRecQuesLoading = false;
    },
    [fetchProgramsRecommendedQuestions.rejected]: (state, { payload }) => {
      state.programRecQuesLoading = false;
    },
    // Programs modules
    [fetchAllProgramsModules.pending]: (state) => {
      state.programModulesLoading = true;
    },
    [fetchAllProgramsModules.fulfilled]: (state, { payload }) => {
      state.programModules = payload?.results;
      state.programModulesCount = payload?.count ? payload.count : 0;
      state.programModulesLoading = false;
    },
    [fetchAllProgramsModules.rejected]: (state, { payload }) => {
      state.programModulesLoading = false;
    },
    // Programs module detail
    [fetchProgramModuleDetails.pending]: (state) => {
      state.programModuleDetailLoading = true;
    },
    [fetchProgramModuleDetails.fulfilled]: (state, { payload }) => {
      if (payload?.results && payload.results.length > 0) {
        state.programModuleDetail = payload.results[0];
        state.moduleCreateName = payload.results[0].module_name;
        state.moduleMedia = payload.results[0].media;
        state.moduleCreateDescription = payload.results[0].description;
        state.moduleCreateInternalNotes = payload.results[0].internal_notes;
        state.moduleCreateWithCertificate = payload.results[0].with_certificate;
        state.moduleCreateType = payload.results[0].module_type;
        state.moduleCreateRole = payload.results[0].module_role;
        state.moduleCreateCategory = payload.results[0].module_categories;
        state.moduleCreateLearnPoint = payload.results[0].learning_point;
        state.moduleCreateFeedVideo = payload.results[0].media;
        state.programModulesCreateSelQues = payload.results[0].questions_set;
        state.programModulesCreateSelQuesDisplay = payload?.results[0]
          ?.question_detail_set
          ? payload.results[0].question_detail_set
          : [];
      }
      state.programModuleDetailLoading = false;
    },
    [fetchProgramModuleDetails.rejected]: (state, { payload }) => {
      state.programModuleDetailLoading = false;
    },
    // Programs modules create
    [createNewProgramModule.pending]: (state) => {
      state.programModuleCreating = true;
    },
    [createNewProgramModule.fulfilled]: (state, { payload }) => {
      state.programModuleCreating = false;
    },
    [createNewProgramModule.rejected]: (state, { payload }) => {
      state.programModuleCreating = false;
    },
    // Programs modules delete
    [deleteProgramModule.pending]: (state) => {
      state.programModuleDeleting = true;
    },
    [deleteProgramModule.fulfilled]: (state, { payload }) => {
      state.programModuleDeleting = false;
    },
    [deleteProgramModule.rejected]: (state, { payload }) => {
      state.programModuleDeleting = false;
    },
    // Programs modules duplicate
    [duplicateProgramModule.pending]: (state) => {
      state.programModuleDuplicating = true;
    },
    [duplicateProgramModule.fulfilled]: (state, { payload }) => {
      state.programModuleDuplicating = false;
    },
    [duplicateProgramModule.rejected]: (state, { payload }) => {
      state.programModuleDuplicating = false;
    },
    // Programs list
    [fetchAllPrograms.pending]: (state) => {
      state.programListLoading = true;
    },
    [fetchAllPrograms.fulfilled]: (state, { payload }) => {
      state.programList = payload?.results;
      state.programListCount = payload?.count ? payload.count : 0;
      if (
        state.programListClientAdminlist.length === 0 ||
        payload.previous === null
      ) {
        state.programListClientAdminlist = payload?.results || [];
      } else {
        state.programListClientAdminlist = [
          ...state.programListClientAdminlist,
          ...(payload?.results || []),
        ];
      }

      // Store current page number
      state.programListPage = payload.next
        ? parseInt(new URL(payload.next).searchParams.get("page")) - 1
        : Math.ceil((payload?.count || 0) / state.programListPageSize);

      state.programListLoading = false;
    },
    [fetchAllPrograms.rejected]: (state) => {
      state.programListLoading = false;
    },
    // Program organization list
    [fetchAllOrganization.pending]: (state) => {
      state.programOrgLoading = true;
    },
    [fetchAllOrganization.fulfilled]: (state, { payload }) => {
      state.programOrgList = payload?.results;
      state.programOrgListCount = payload?.count ? payload.count : 0;
      state.programOrgLoading = false;
    },
    [fetchAllOrganization.rejected]: (state, { payload }) => {
      state.programOrgLoading = false;
    },
    // Programs delete
    [deleteProgram.pending]: (state) => {
      state.programDeleting = true;
    },
    [deleteProgram.fulfilled]: (state, { payload }) => {
      state.programDeleting = false;
    },
    [deleteProgram.rejected]: (state, { payload }) => {
      state.programDeleting = false;
    },
    // Programs duplicate
    [duplicateProgram.pending]: (state) => {
      state.programDuplicating = true;
    },
    [duplicateProgram.fulfilled]: (state, { payload }) => {
      state.programDuplicating = false;
    },
    [duplicateProgram.rejected]: (state, { payload }) => {
      state.programDuplicating = false;
    },
    // Programs create
    [createNewProgram.pending]: (state) => {
      state.programCreateLoading = true;
    },
    [createNewProgram.fulfilled]: (state, { payload }) => {
      state.programCreateLoading = false;
    },
    [createNewProgram.rejected]: (state, { payload }) => {
      state.programCreateLoading = false;
    },
    // Programs update
    [updateNewProgram.pending]: (state) => {
      state.programCreateLoading = true;
    },
    [updateNewProgram.fulfilled]: (state, { payload }) => {
      state.programCreateLoading = false;
    },
    [updateNewProgram.rejected]: (state, { payload }) => {
      state.programCreateLoading = false;
    },
    // Programs chapters fetch
    [fetchProgramChapters.pending]: (state) => {
      state.programChaptersList = [];
      state.programCreateSelModules = [];
      state.programCreateExistingModules = [];
      state.programCreateSelModulesDisplay = [];
    },
    [fetchProgramChapters.fulfilled]: (state, { payload }) => {
      if (payload?.results && payload.results.length > 0) {
        state.programChaptersList = payload.results;
      }
    },
    [fetchProgramChapters.rejected]: (state, { payload }) => {
      state.programChaptersList = [];
      state.programCreateSelModules = [];
      state.programCreateExistingModules = [];
      state.programCreateSelModulesDisplay = [];
    },
    // Programs chapters delete
    [deleteProgramChapter.pending]: (state) => {
      state.programCreateLoading = true;
    },
    [deleteProgramChapter.fulfilled]: (state, { payload }) => {
      state.programCreateLoading = false;
    },
    [deleteProgramChapter.rejected]: (state, { payload }) => {
      state.programCreateLoading = false;
    },
    // Programs detail
    [fetchProgramDetails.pending]: (state) => {
      state.programDetailLoading = true;
    },
    [fetchProgramDetails.fulfilled]: (state, { payload }) => {
      if (payload?.results && payload.results.length > 0) {
        state.programDetail = payload.results[0];
        state.programCreateHeading = payload.results[0]?.title;
        state.programCreateSubHeading = payload.results[0]?.sub_title;
        state.programCreateInternalType =
          payload.results[0]?.internal_program_type || "";
        state.programCreateInternalNotes =
          payload.results[0]?.internal_notes || "";
        state.programCreateDescription = payload.results[0]?.description;
        state.programCreateStructure =
          payload.results[0]?.program_structure &&
          Array.isArray(payload.results[0].program_structure)
            ? payload.results[0]?.program_structure.toString()
            : payload.results[0]?.program_structure;
        state.programCreateLearnObjs =
          payload.results[0]?.learning_objectives &&
          Array.isArray(payload.results[0].learning_objectives)
            ? payload.results[0]?.learning_objectives.toString()
            : payload.results[0]?.learning_objectives;
        state.programCreateCME = payload.results[0]?.cme_earned;
        state.programCreateRole = payload.results[0]?.roles;
        state.programCreateUserType = payload.results[0]?.user_type;
        state.programHandouts = payload.results[0]?.handouts;
        state.hasSubmissions = payload.results[0]?.has_submissions;
        state.programCreateCategory = payload.results[0]?.categories;
        state.programCreateLearnPoint = payload.results[0]?.learning_points;
        state.programCreateAssignedOrgs = payload.results[0]?.organization;
        state.programCreateAssignedUsers = payload.results[0]?.users;
        state.programCreateAssignedUserGroups = payload.results[0]?.groups;
        state.programCreateIsSequential = payload.results[0]?.sequential;
        state.programCreateIsMandatory = payload.results[0]?.mandatory;
        state.programCreateCoverImagePreview = payload.results[0]?.image;
        state.programVisibility = payload.results[0]?.visible_on;
        state.programVisibilityCustomerAdmin =
          payload.results[0]?.visible_on?.includes("client_admin")
            ? "yes"
            : "no";
        state.programVisibilityCoder = payload.results[0]?.visible_on?.includes(
          "coder"
        )
          ? "yes"
          : "no";
        state.programVisibleToOrgs =
          payload.results[0]?.visible_to_organizations;
        state.programVisibleAllOrgs = payload.results[0]?.visible_to_all_orgs;
        state.programType = payload.results[0]?.program_variant;
      }
      state.programDetailLoading = false;
    },
    [fetchProgramDetails.rejected]: (state, { payload }) => {
      state.programDetailLoading = false;
    },
    // Fetch program question bulk review
    [fetchProgramBulkUploadReview.pending]: (state) => {
      state.programQuesUploadReviewLoading = true;
    },
    [fetchProgramBulkUploadReview.fulfilled]: (state, { payload }) => {
      if (payload?.total_questions && payload.total_questions > 0) {
        state.programQuesUploaderReviewCountTotal = payload.total_questions;
        state.programQuesUploaderReviewCountApproved =
          payload?.total_approved_questions
            ? payload.total_approved_questions
            : 0;
        state.programQuesUploaderReviewCountError =
          payload?.total_error_questions ? payload.total_error_questions : 0;
        state.programQuesUploaderReviewErrorList = payload?.error_question_list
          ? payload.error_question_list
          : [];
        state.programQuesUploaderValidationList = payload?.validation_error_list
          ? payload.validation_error_list
          : [];
      }
      state.programQuesUploadReviewLoading = false;
    },
    [fetchProgramBulkUploadReview.rejected]: (state, { payload }) => {
      state.programQuesUploadReviewLoading = false;
    },
    // Fetch program question bulk review - edit question
    [fetchProgramBulkUploadReviewQuestion.pending]: (state) => {
      state.programQuesUploadEditLoading = true;
    },
    [fetchProgramBulkUploadReviewQuestion.fulfilled]: (state, { payload }) => {
      state.programQuesUploadEditLoading = false;
      if (payload?.question) {
        state.programQuesUploadEditStatus = payload.status
          ? payload.status
          : "EXPIRED";
        state.programQuesUploadEditType = payload.type ? payload.type : "SC";
        state.programQuesUploadEditQuestion = payload.question
          ? payload.question
          : "";
        state.programQuesUploadEditChoices = payload.choices
          ? payload.choices
          : [];
        state.programQuesUploadEditAnswer = payload.answer
          ? payload.answer
          : [];
        state.programQuesUploadEditExplanation = payload.explanation
          ? payload.explanation
          : "";
        state.programQuesUploadEditCategory = payload.category
          ? payload.category
          : [];
        state.programQuesUploadEditLearningPoint = payload.learning_point
          ? payload.learning_point
          : [];
        state.programQuesUploadEditComplexity = payload.complexity
          ? payload.complexity && complexityList.includes(payload.complexity)
            ? payload.complexity
            : "BEGINNER"
          : "BEGINNER";
        state.programQuesUploadEditModuleType = payload.module_type
          ? payload.module_type
          : [];
        state.programQuesUploadEditUserRole = payload.role ? payload.role : [];
        state.programQuesUploadEditv28Compatibility = payload.v28_compatibility
          ? payload.v28_compatibility
          : null;
        state.programQuesUploadEditErrorList = payload.errors
          ? payload.errors
          : [];
        state.programQuesUploadTag = payload.question_tags;
      }
    },
    [fetchProgramBulkUploadReviewQuestion.rejected]: (state, { payload }) => {
      state.programQuesUploadEditLoading = false;
    },
    // Upload question bulk review
    [uploadBulkUploadFile.pending]: (state) => {
      state.programQuesUploadReviewLoading = true;
    },
    [uploadBulkUploadFile.fulfilled]: (state, { payload }) => {
      if (
        payload?.total_uploaded_questions &&
        payload.total_uploaded_questions > 0
      ) {
        state.programQuesUploaderReviewCountTotal =
          payload.total_uploaded_questions;
        state.programQuesUploaderReviewCountApproved =
          payload?.total_approved_questions
            ? payload.total_approved_questions
            : 0;
        state.programQuesUploaderReviewCountError =
          payload?.total_error_questions ? payload.total_error_questions : 0;
        state.programQuesUploaderReviewErrorList = payload?.error_question_list
          ? payload.error_question_list
          : [];
      }
      state.programQuesUploadReviewLoading = false;
    },
    [uploadBulkUploadFile.rejected]: (state, { payload }) => {
      state.programQuesUploadReviewLoading = false;
    },
    // Programs questions - bulk upload discard
    [discardStagedQuestion.pending]: (state) => {
      state.programQuesBulkDiscardLoading = true;
    },
    [discardStagedQuestion.fulfilled]: (state, { payload }) => {
      state.programQuesBulkDiscardLoading = false;
    },
    [discardStagedQuestion.rejected]: (state, { payload }) => {
      state.programQuesBulkDiscardLoading = false;
    },
    // Programs questions - staged edit
    [updateStagedQuestion.pending]: (state) => {
      state.programQuesEditSaveLoading = true;
    },
    [updateStagedQuestion.fulfilled]: (state, { payload }) => {
      state.programQuesEditSaveLoading = false;
    },
    [updateStagedQuestion.rejected]: (state, { payload }) => {
      state.programQuesEditSaveLoading = false;
    },
    // Programs questions - staged publish
    [publishStagedQuestion.pending]: (state) => {
      state.programQuesPublishLoading = true;
    },
    [publishStagedQuestion.fulfilled]: (state, { payload }) => {
      state.programQuesPublishLoading = false;
    },
    [publishStagedQuestion.rejected]: (state, { payload }) => {
      state.programQuesPublishLoading = false;
    },
    [fetchQuestionAnalytics.pending]: (state) => {
      state.programQuesAnalyticsLoading = true;
    },
    [fetchQuestionAnalytics.fulfilled]: (state, { payload }) => {
      state.programQuesAnalytics = payload;
      state.programQuesAnalyticsLoading = false;
    },
    [fetchQuestionAnalytics.rejected]: (state, { payload }) => {
      state.programQuesAnalyticsLoading = false;
    },
    [updateProgramQuestion.rejected]: (state, { payload }) => {
      state.programQuesUpdateLoading = false;
      state.programQuesUpdateErrors = payload?.errors ? payload.errors : {};
    },
    [fetchProgramOrModuleInternalNotesFilters.pending]: (state) => {
      state.programInternalNotesLoading = true;
    },
    [fetchProgramOrModuleInternalNotesFilters.fulfilled]: (
      state,
      { payload }
    ) => {
      state.programInternalNotesList =
        payload.results && payload.results.length > 0
          ? payload.results
              .map((type) => type.internal_notes)
              .filter((type) => type !== null)
          : [];
      state.programInternalNotesCount = payload?.count ? payload.count : 0;
      state.programInternalNotesLoading = false;
    },
    [fetchProgramOrModuleInternalNotesFilters.rejected]: (
      state,
      { payload }
    ) => {
      state.programInternalNotesLoading = false;
    },
    [fetchProgramTypeFilters.pending]: (state) => {
      state.programTypeLoading = true;
    },
    [fetchProgramTypeFilters.fulfilled]: (state, { payload }) => {
      state.programTypesList =
        payload.results && payload.results.length > 0
          ? payload.results
              .map((type) => type.internal_program_type)
              .filter((type) => type !== null)
          : [];
      state.programTypeLoading = false;
    },
    [fetchProgramTypeFilters.rejected]: (state, { payload }) => {
      state.programTypeLoading = false;
    },
    [fetchAllLearningPoints.pending]: (state) => {
      state.programLearningPointsLoading = true;
    },
    [fetchAllLearningPoints.fulfilled]: (state, { payload }) => {
      state.programLearningPointsCount = payload?.count ? payload.count : 0;
      if (
        state.programLearningPoints.length === 0 ||
        payload.previous === null
      ) {
        state.programLearningPoints = payload?.results || [];
      } else {
        state.programLearningPoints = [
          ...state.programLearningPoints,
          ...(payload?.results || []),
        ];
      }
      state.programLearningPointsPage = payload.next
        ? parseInt(new URL(payload.next).searchParams.get("page")) - 1
        : Math.ceil(
            (payload?.count || 0) / state.programLearningPointsPageSize
          );
      state.programLearningPointsLoading = false;
    },
    [fetchAllLearningPoints.rejected]: (state, { payload }) => {
      state.programLearningPointsLoading = false;
    },
  },
});

export const {
  setModuleCreateStep,
  resetProgramModuleCreateData,
  toggleModCreateQuesSelect,
  setProgCreateStep,
  setProgramSliceData,
  resetHandoutDetail,
  toggleProgramSliceArrayData,
  removeDeletedFromExistingModules,
  addToProgCreateModsSelect,
  resetProgramCreateData,
  setProgramCreateSelModulesDisplay,
  toggleProgCreateModsSelect,
  updateProgModChapterFields,
  setQuestionUpdateState,
  setQuestionUpdateValidationErrors,
  validateProgramQuestion,
  appendUpdatedHandout,
  updateProgramHandout,
} = programsSlice.actions;

export default programsSlice.reducer;
